import { Contact } from '../contact/contact';
import { Entity, TenantEntity } from '../entity';
import { WorkOrder } from './workorder';
import { PriceBook } from '../price.book';
import { PurchaseOrder } from '../purchase/purchase.order';
import { Address } from '../shared/address';
import { EmbeddedCode } from '../shared/code';
import { FilterValue } from '../shared/filter';
import { TaxRate } from '../taxrate/tax.rate';
import { Company } from '../tenant/company';
import { WorkOrderStatus } from './workorder.status';


export enum TemplateType {
    CustomerInvoice = 'Customer Invoice',
    TechnicianInvoice = 'Technician Invoice',
    TechnicianWorkOrder = 'Technician Work Order',
    Quotation = 'Quotation',
    Codes = 'Codes',
    JobAuditReport = 'JobAuditReport',
    WorkOrderSummary = 'WorkOrder Summary',
    PurchaseOrder = 'Purchase Order',
    Variation = 'Variation',
}

export interface InvoiceSummary {
    _id: string;
    description: string;
    jobNumber?: string;
    workOrderNumber?: string;
    completedDate?: Date;
    street: string;
    suburb: string;
    postcode: string;
    status: WorkOrderStatus;
    customerWO: string;
    technician?: Entity;
    customer?: Entity;
    jobType?: Entity;
    invoice?: Entity;
}

export interface CustomerInvoiceSummary extends InvoiceSummary {
    purchaseOrders: PurchaseOrder[];
    workOrders: Partial<WorkOrder>[];
    sellTotal: number;
    purchaseOrderTotal: number;
    invoiceTotal: number;
}

export interface TechnicianInvoiceSummary extends InvoiceSummary {
    codes: Partial<EmbeddedCode>[];
    buyTotal: number;
    billTotal: number;
}

export interface TemplateSetting extends Entity {
    title?: string;
    templateContent?: any; // provide the template by binary data
    templatePath?: any; // provide the template by path (file system, Azure)
    templateName?: string; // provide the template by file name in templates default
    type: TemplateType;
    mustache?: boolean;
}


export interface FinanceViewSummary {
    _id: string;
    name: string;
    isDefault: boolean;
    system: boolean;
    selected: boolean;
    filters?: FinanceViewFilters;
    ownerId?: string;
}

export enum FinanceDefaultView {
    Pending = 'Pending',
    InvoicedBilled = 'Invoiced /Billed',
    Error = 'Error'
}

export interface FinanceView extends TenantEntity {
    description: string;
    filters: FinanceViewFilters;
    owner: Entity;
    isDefault?: boolean;
    isPublic?: boolean;
    system?: boolean;
}

export interface FinanceViewFilters {
    text?: string;
    customers?: FilterValue[];
    technicians?: FilterValue[];
    status?: FinanceDefaultView;
}

export interface FinanceViewFiltersRaw extends FinanceViewFilters {
    jobNumbers: string[];
    total?: number;
}


export interface AccountingInvoiceSummary {
    jobId?: string;
    workOrderId?: string;
    description?: string;
    taxRate: TaxRate;
    invoiceDate?: Date;
    address?: Address;
    customerWorkOrder: string;
    workOrderNumber: string;
    invoiceNumber?: string;
    billingCompany?: Company;
    technician?: TenantEntity;
    customer?: Contact;
    pricebook?: PriceBook;
    sellTotal?: number;
    buyTotal?: number;
}
